@if (breadcrumbs?.length > 0 && breadcrumbs[0].url !== '/dashboard' && !isDisabled && (isLoggedIn$ | async)) {
  <ol
    class="re-list-none re-p-15 re-inline-block lg:re-bg-white lg:re-mx-30">
    <li class="re-inline bold">
      <a [routerLink]="'/dashboard'" class="hover:re-text-secondary-hover">
        {{ 'breadcrumb.dashboard' | translate }}
      </a>
      <span>&nbsp;/&nbsp;</span>
    </li>
    @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
      <li
        class="re-inline">
        @if (!last) {
          <a [routerLink]="breadcrumb.url" class="hover:re-text-secondary-hover bold">
            {{ breadcrumb?.label | translate }}
          </a>
        }
        @if (!last) {
          <span class="bold">&nbsp;/&nbsp;</span>
        }
        @if (last) {
          <span>
            {{ breadcrumb?.label | translate }}
          </span>
        }
      </li>
    }
  </ol>
}
